// import PhotoSwipeLightbox from 'https://cdnjs.cloudflare.com/ajax/libs/photoswipe/5.4.4/photoswipe-lightbox.esm.min.js';

// const lightbox = new PhotoSwipeLightbox({
//   gallery: '[id^="Slider-main-"]',
//   children: 'a[itemprop="contentUrl"]',
//   wheelToZoom: true,
//   pswpModule: () => import('https://cdnjs.cloudflare.com/ajax/libs/photoswipe/5.4.4/photoswipe.esm.min.js'),
//   allowPanToNext: false
// });

// lightbox.init();


// import PhotoSwipeLightbox from 'https://cdnjs.cloudflare.com/ajax/libs/photoswipe/5.4.4/photoswipe-lightbox.esm.min.js';

// class AppMedia extends HTMLElement {
//   constructor() {
//     super();
//     this.sliderElement = this.querySelector('[id^="Slider-main-"]');
//     this.thumbElement = this.querySelector('[id^="Slider-thumb-"]');

//     if (!this.sliderElement) return;

//     this.initSliders();
//     this.initPhotoSwipe();
//   }

//   initSliders() {
//     // Vertical Thumbnails configuration
//     this.thumbsSwiper = new Swiper(this.thumbElement, {
//       direction: 'vertical',
//       slidesPerView: 3.2,
//       loop: false, // Turn off looping for precise active indexing match
//       spaceBetween: 20,
//       freeMode: true,
//       watchSlidesProgress: true,
//     });

//     // Main Swiper configuration
//     this.mainSwiper = new Swiper(this.sliderElement, {
//       slidesPerView: 1,
//       loop: false,
//       spaceBetween: 20,
//       thumbs: {
//         swiper: this.thumbsSwiper,
//       }
//     });
//   }

//   initPhotoSwipe() {
//     this.lightbox = new PhotoSwipeLightbox({
//       gallery: this.sliderElement,
//       children: 'a[itemprop="contentUrl"]',
//       wheelToZoom: true,
//       allowPanToNext: false,
//       pswpModule: () => import('https://cdnjs.cloudflare.com/ajax/libs/photoswipe/5.4.4/photoswipe.esm.min.js'),
//     });

//     // Parse data-type custom override attribute 
//     this.lightbox.addFilter('itemData', (itemData, index) => {
//       const linkEl = itemData.element;
//       if (linkEl && linkEl.getAttribute('data-type') === 'video') {
//         itemData.type = 'video';
//         itemData.videoTemplateId = linkEl.getAttribute('data-video-id');
//       }
//       return itemData;
//     });

//     // Create the custom HTML DOM element context when type is 'video'
//     this.lightbox.on('contentLoad', (e) => {
//       const { content } = e;
//       if (content.type === 'video') {
//         e.preventDefault();

//         // Target template element content
//         const template = document.getElementById(content.data.videoTemplateId);
//         console.log(template);

//         if (!template) return;

//         const container = document.createElement('div');
//         container.className = 'pswp-video-wrapper';
//         container.appendChild(template.content.cloneNode(true));

//         content.element = container;
//         console.log(content);

//       }
//     });

//     // Auto-destroy iframe/video stream instances when user exits lightbox
//     this.lightbox.on('contentDestroy', (e) => {
//       const { content } = e;
//       if (content.type === 'video' && content.element) {
//         const video = content.element.querySelector('video');
//         const iframe = content.element.querySelector('iframe');
//         if (video) video.pause();
//         if (iframe) iframe.src = ''; // Force stops YouTube/Vimeo stream instantly
//       }
//     });

//     this.lightbox.init();
//   }
// }

// if (!customElements.get('app-media-gallery')) {
//   customElements.define('app-media-gallery', AppMedia);
// }


import PhotoSwipeLightbox from 'https://cdnjs.cloudflare.com/ajax/libs/photoswipe/5.4.4/photoswipe-lightbox.esm.min.js';

class AppMedia extends HTMLElement {
  constructor() {
    super();
    this.sliderElement = this.querySelector('[id^="Slider-main-"]');
    this.thumbElement = this.querySelector('[id^="Slider-thumb-"]');

    if (!this.sliderElement) return;

    this.initSliders();
    this.initPhotoSwipe();
  }

  initSliders() {
    this.thumbsSwiper = new Swiper(this.thumbElement, {
      direction: 'vertical',
      slidesPerView: 3.3,
      loop: false,
      spaceBetween: 20,
      watchSlidesProgress: true,
    });

    this.mainSwiper = new Swiper(this.sliderElement, {
      slidesPerView: 1.2,
      loop: false,
      spaceBetween: 20,
      thumbs: {
        swiper: this.thumbsSwiper,
      },
      breakpoints: {
        // When the browser window width is >= 1024px
        1024: {
          slidesPerView: 1, // Desktop layout override
          spaceBetween: 20, // Optional: adjust space if needed
        }
      }
    });
  }

  initPhotoSwipe() {
    this.lightbox = new PhotoSwipeLightbox({
      gallery: this.sliderElement,
      children: 'a[itemprop="contentUrl"]',
      wheelToZoom: false,
      allowPanToNext: false,
      pswpModule: () => import('https://cdnjs.cloudflare.com/ajax/libs/photoswipe/5.4.4/photoswipe.esm.min.js'),
    });


    this.lightbox.addFilter('itemData', (itemData) => {
      const linkEl = itemData.element;
      if (linkEl && linkEl.getAttribute('data-type') === 'video') {
        itemData.type = 'video';
        itemData.videoTemplateId = linkEl.getAttribute('data-video-id');
        itemData.msrc = linkEl.getAttribute('data-poster');
      }
      return itemData;
    });


    this.lightbox.on('contentLoad', (e) => {
      const { content } = e;
      if (content.type === 'video') {
        e.preventDefault();

        const template = document.getElementById(content.data.videoTemplateId);
        if (!template) return;


        const container = document.createElement('div');
        container.className = 'pswp-video-container';
        container.style.position = 'relative';
        container.style.width = '100%';
        container.style.height = '100%';
        container.style.display = 'flex';
        container.style.justifyContent = 'center';
        container.style.alignItems = 'center';


        const videoContent = template.content.cloneNode(true);
        const nativeVideo = videoContent.querySelector('video');
        const iframeVideo = videoContent.querySelector('iframe');

        if (nativeVideo) {
          nativeVideo.style.maxWidth = '100%';
          nativeVideo.style.maxHeight = '100%';
          nativeVideo.style.width = '100%';
          nativeVideo.style.height = '100%';
          nativeVideo.controls = true;
        }

        if (iframeVideo) {
          iframeVideo.style.width = '100%';
          iframeVideo.style.height = '100%';
          iframeVideo.style.aspectRatio = `${content.width} / ${content.height}`;
        }

        container.appendChild(videoContent);


        if (content.data.msrc) {
          const posterOverlay = document.createElement('div');
          posterOverlay.className = 'pswp-custom-poster-overlay';
          posterOverlay.style.position = 'absolute';
          posterOverlay.style.top = '0';
          posterOverlay.style.left = '0';
          posterOverlay.style.width = '100%';
          posterOverlay.style.height = '100%';
          posterOverlay.style.backgroundImage = `url(${content.data.msrc})`;
          posterOverlay.style.backgroundSize = 'contain';
          posterOverlay.style.backgroundPosition = 'center';
          posterOverlay.style.backgroundRepeat = 'no-repeat';
          posterOverlay.style.cursor = 'pointer';
          posterOverlay.style.display = 'flex';
          posterOverlay.style.justifyContent = 'center';
          posterOverlay.style.alignItems = 'center';
          posterOverlay.style.zIndex = '10';

          const playButton = document.createElement('div');
          playButton.innerHTML = '▶';
          playButton.style.fontSize = '3rem';
          playButton.style.color = '#fff';
          playButton.style.backgroundColor = 'rgba(0, 0, 0, 0.6)';
          playButton.style.width = '70px';
          playButton.style.height = '70px';
          playButton.style.borderRadius = '50%';
          playButton.style.display = 'flex';
          playButton.style.justifyContent = 'center';
          playButton.style.alignItems = 'center';
          posterOverlay.appendChild(playButton);


          const handlePlayIntent = () => {
            posterOverlay.style.display = 'none';
            if (nativeVideo) {
              nativeVideo.play().catch(err => console.error("Playback interrupted:", err));
            } else if (iframeVideo) {
              let currentSrc = iframeVideo.src;
              if (!currentSrc.includes('autoplay=1')) {
                iframeVideo.src = currentSrc.includes('?') ? `${currentSrc}&autoplay=1` : `${currentSrc}?autoplay=1`;
              }
            }
          };

          posterOverlay.addEventListener('click', handlePlayIntent);
          container.appendChild(posterOverlay);


          if (nativeVideo) {
            nativeVideo.addEventListener('pause', () => {
              posterOverlay.style.display = 'flex';
            });
            nativeVideo.addEventListener('play', () => {
              posterOverlay.style.display = 'none';
            });
          }
        }

        content.element = container;
      }
    });


    this.lightbox.on('afterChange', () => {
      const pswpInstance = this.lightbox.pswp;
      if (!pswpInstance) return;

      // Loop through all currently allocated slides in the PhotoSwipe viewport memory
      pswpInstance.slides.forEach((slide) => {
        // If the slide is NOT the active main index view slide, pause its contents
        if (slide.index !== pswpInstance.currIndex) {
          const inactiveContainer = slide.content?.element;
          if (!inactiveContainer) return;

          const video = inactiveContainer.querySelector('video');
          const iframe = inactiveContainer.querySelector('iframe');
          const posterOverlay = inactiveContainer.querySelector('.pswp-custom-poster-overlay');

          if (video && !video.paused) {
            video.pause();
            if (posterOverlay) posterOverlay.style.display = 'flex';
          }

          if (iframe) {
            const currentSrc = iframe.src;
            if (currentSrc.includes('autoplay=1')) {
              iframe.src = currentSrc.replace('&autoplay=1', '').replace('?autoplay=1', '');
              if (posterOverlay) posterOverlay.style.display = 'flex';
            }
          }
        }
      });
    });


    this.lightbox.on('contentDestroy', (e) => {
      const { content } = e;
      if (content.type === 'video' && content.element) {
        const video = content.element.querySelector('video');
        const iframe = content.element.querySelector('iframe');
        if (video) video.pause();
        if (iframe) iframe.src = '';
      }
    });


    this.lightbox.on('slideDeactivate', (e) => {
      const { slide } = e;
      const inactiveContainer = slide.content?.element;
      if (!inactiveContainer) return;

      const video = inactiveContainer.querySelector('video');
      const iframe = inactiveContainer.querySelector('iframe');
      const posterOverlay = inactiveContainer.querySelector('.pswp-custom-poster-overlay');


      if (video && !video.paused) {
        video.pause();
        if (posterOverlay) posterOverlay.style.display = 'flex';
      }


      if (iframe) {
        const currentSrc = iframe.src;
        if (currentSrc.includes('autoplay=1')) {
          iframe.src = currentSrc.replace('&autoplay=1', '').replace('?autoplay=1', '');
          if (posterOverlay) posterOverlay.style.display = 'flex';
        }
      }
    });

    this.lightbox.init();
  }
}

if (!customElements.get('app-media-gallery')) {
  customElements.define('app-media-gallery', AppMedia);
}